import styled from 'styled-components';
import { colourPalette } from 'styles/styles';

export const LoginPageStyle = {
  Container: styled.div`
    height: 100vh;
    overflow: hidden;
    background: ${colourPalette.violet500};
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    position: relative;
  `,
  BlueBox: styled.div`
    background-color: #b0f4ff;
    width: 120%;
    height: 100%;
    transform: rotate(5.5deg);
    position: absolute;
    top: -50%;
    left: -10%;
    z-index: 1;
  `,
  FormCard: styled.div`
    background: white;
    box-shadow: 0px 1px 12px rgba(24, 30, 38, 0.1);
    border-radius: 8px;
    padding: 24px;
    width: 480px;
    z-index: 2;
    position: relative;
    @media screen and (max-width: 500px) {
      width: 100%;
      height: 100vh;
      padding: 48px 24px;
      margin-top: 76px;
      border-radius: 0px;
    }
  `,
  LogoContainer: styled.div`
    position: absolute;
    z-index: 3;
    top: 0;
    left: 0;
    right: 0;
    padding: 24px;
    height: 80px;
    @media screen and (max-width: 500px) {
      background: white;
    }
  `,
};
